<template>
  <section :class="['top', topicWrapper.topic.imageUrl ? 'top-offset' : '']" >
    <div class="banner" v-if="topicWrapper.topic.imageUrl">
      <img :src="topicWrapper.topic.imageUrl" alt="banner">
      <span class="gradient"></span>
    </div>
    <div :class="topicWrapper.topic.imageUrl ? 'offset' : ''">
      <div v-if="topicWrapper" class="info">
        <span class="title">
          {{topicWrapper.topic.title}}
          <span class="label" v-if="topicWrapper.topic.label">{{topicWrapper.topic.label}}</span>
        </span>
        <button class="follow" @click="openApp">关注</button>
        <div class="count">
          <span class="count-left">{{topicWrapper.topic.feedCount}}篇内容</span>
          <span>{{topicWrapper.topic.followCount}}人关注</span>
        </div>
        <div class="description">
          {{topicWrapper.topic.description}}
        </div>
        <div class="notice">
          <div 
            v-for="(item, index) in topicWrapper.noticeFeedWrappers" 
            :key="index">
            <a class="notice-item" :href="`/share/feed/${item.topicFeed.feedId}`">
              <span class="label">{{item.topicFeed.label}}</span>
              <span class="summary">{{item.topicFeed.summary}}</span>
            </a>
          </div>
        </div>
        <div class="vote" v-if="voteOptions">
          <div class="options">
            <span :class="[voteOptions.length === 3 ? 'item' : 'item-2']" v-for="item in voteOptions" :key="item.option.optionId">
              <span class="box-text" @click="openApp">
                {{item.option.optionText}}
              </span>
              <div class="vote-users">
                <span v-for="(user, index) in item.hotVoteUsers" :key="index" class="avatar">
                  <img v-if="user" :src="user.imageUrl" alt="">
                  <span v-else class="empty-avatar"></span>
                </span>
              </div>
              <span class="count"> ? 人支持</span>
            </span>
          </div>
          <div class="percent">选择观点后查看百分比</div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Top',
  props: {
    topicWrapper: {
      type: Object,
      default: () => {return {}}
    },
    openApp: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      voteOptions: null
    }
  },
  watch: {
    topicWrapper: {
      handler: function (value) {
        let voteOptions = null
        if(value.voteOptions) {
          voteOptions = value.voteOptions
          voteOptions = voteOptions.map(item => {
            if(!item.hotVoteUsers.length) {
              item.hotVoteUsers.length = 3
            }
            return item
          })
        }
        this.voteOptions = voteOptions
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.top {
  position: relative;
  font-size: 0;
  padding-top: .32rem;
  .info {
    z-index: 9;
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    width: 7rem;
    background: #FFFFFF;
    box-shadow: 0 .32rem .64rem 0 rgba(0,0,0,0.07);
    border-radius: .48rem;
    padding: .4rem;
    .title {
      font-family: HYQiHei-FZS;
      font-size: .44rem;
      color: #444444;
      letter-spacing: 0.2px;
      line-height: .58rem;
      font-weight: 500;
      display: inline-block;
      width: 4.62rem;
      .label  {
        display: inline-block;
        line-height: .36rem;
        height: .36rem;
        padding: 0 .13rem;
        border: 1px solid #CE5959;
        border-radius: .18rem;
        font-family: HYQiHei-EZS;
        font-size: .22rem;
        font-weight: normal;
        color: #CE5959;
        letter-spacing: 0;
        text-align: center;
        vertical-align: middle;
      }
    }
    .follow {
      display: inline-block;
      width: 1.2rem;
      height: .72rem;
      background: #CE5959;
      border-radius: 1rem;
      font-family: HYQiHei-EZS;
      font-size: .28rem;
      color: #FFFFFF;
      text-align: center;
      line-height: .42rem;
      vertical-align: top;
      margin-left: .34rem;
      &:active {
        background-color: rgba(205, 90, 90, 0.5);
      }
    }
    .count {
      margin: .32rem 0 .24rem 0;
      font-family: HYQiHei-EZS;
      font-size: .24rem;
      color: #444444;
      .count-left {
        margin-right: .32rem;
      }
    }
    .description {
      font-family: HYQiHei-EZS;
      font-size: .28rem;
      color: #808080;
      letter-spacing: 0;
      line-height: .48rem;
      word-break: break-all;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    .notice {
      .notice-item {
        display: inline-block;
        box-sizing: border-box;
        line-height: .48rem;
        border: 1px solid #B89477;
        border-radius: .24rem;
        padding: 0 .24rem 0 .09rem;
        margin-top: .24rem;
        .label {
          display: inline-block;
          height: .32rem;
          padding: 0 .1rem;
          line-height: .32rem;
          font-family: HYQiHei-EZS;
          font-size: .22rem;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          box-sizing: border-box;
          background: #B89477;
          border-radius: .49rem;
          margin-right: .2rem;
          vertical-align: middle;
        }
        .summary {
          display: inline-block;
          font-family: HYQiHei-EZS;
          font-size: .26rem;
          line-height: .32rem;
          height: .32rem;
          color: #B89477;
          vertical-align: middle;
        }
      }
    }
    .vote {
      margin-top: .4rem;
      .options {
        display: inline-block;
        display: flex;
        justify-content: space-between;
        .item-2 {
          width: 2.8rem;
          text-align: center;
        }
        .item {
          width: 1.91rem;
          text-align: center;
        }
        .box-text {
          display: inline-block;
          width: 100%;
          height: 1.24rem;
          line-height: 1.24rem;
          background: #FFFFFF;
          border: 1px solid #EDEDED;
          border-radius: 0.08rem;
          font-family: HYQiHei-FZS;
          font-size: .28rem;
          font-weight: 500;
          color: #444444;
          text-align: center;
        }
        .vote-users {
          margin-top: .32rem;
          .avatar {
            margin-right: .07rem;
            img {
              width: .4rem;
              height: .4rem;
              border-radius: 50%;
            }
            span {
              display: inline-block;
              width: .4rem;
              height: .4rem;
              border-radius: 50%;
              border: 1px dashed #cccccc;
            }
            &:last-child {
              margin: 0;
            }
          }
        }
      }
      .percent {
        width: 100%;
        height: .34rem;
        opacity: 0.8;
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        color: #FFFFFF;
        letter-spacing: .05rem;
        text-align: center;
        line-height: .34rem;
        border-radius: .17rem;
        margin-top: .4rem;
        background-image: linear-gradient(to right, #5F7CCC 0%, #F57979 33%, #FFDA8F  90%);
      }
    }
  }
  .banner {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 1;
    img {
      width: 100%;
      height: 9.56rem;
    }
    .gradient {
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 57%);
    }
  }
  .offset {
    padding-top: 4.4rem;
  }
}
.top-offset {
  min-height: 9.56rem;
}
</style>
